import React from 'react'; // useEffect, useRef は不要になるので削除

interface MiniPreviewProps {
  toggleMiniPreview?: () => void;
  miniPreviewSrc: string; // 画像URLを受け取る
}

/**
 * メインSVGのキャプチャ画像を表示するミニプレビューコンポーネント
 */
export const MiniPreview: React.FC<MiniPreviewProps> = ({
  toggleMiniPreview,
  miniPreviewSrc,
}) => {
  return (
    <div className="mini-preview-container" style={{ 
      position: 'absolute',
      top: '10px',
      right: '10px',
      width: '64px',
      height: '64px',
      border: '2px solid #666',
      borderRadius: '4px',
      overflow: 'hidden',
      boxShadow: '0 3px 6px rgba(0,0,0,0.2)',
      background: '#fff', // 背景は維持
      cursor: 'pointer',
      opacity: 0.95
    }}
    onClick={toggleMiniPreview}
    title="クリックして表示/非表示を切り替え">
      {miniPreviewSrc && (
        <img 
          src={miniPreviewSrc} 
          alt="Mini Preview"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain', // アスペクト比を保ちつつコンテナに収める
          }}
        />
      )}
    </div>
  );
};
